<template>
  <div class="memory" v-loading="loading">
    <template v-if="languageList.length==0&&isRequest">
      <div class="nodata-box">
        <div class="nodata">
          <div class="nodata-left">
            <h2>{{$t('memoryBankV2.createMemoryBank')}}</h2>
            <i></i>
            <p>
              {{$t('memoryBankV2.Multilingualandmultidomaincorpusmanagementtoachievemoreaccurateandefficienttranslation')}}
            </p>
            <el-button class="set_btn" type="primary" @click="addMemory">
              {{$t('memoryBankV2.Newnow')}}
            </el-button>
          </div>
          <div class="nodata-img">

          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="memory_top" v-if="languageList.length>0">
        <!-- <div class="title">翻译记忆</div> -->
        <div class="btn">
          <el-button class="set_btn" type="primary" @click="addMemory">
            {{$t('memoryBankV2.createMemoryBank')}}
          </el-button>
        </div>
      </div>
      <div class="memory_content">
        <div class="memory_item" v-for="(item,index) in languageList" :key="index"
             :id="`${item.sourceLang}_${item.targetLang}${index}`">
          <div class="language_top">
            <span class="left_box"></span>
            <div class="right_box">
              <div class="language_name">
                <span class="folderImg"></span>
                <span
                      class="name">{{$i18n.locale === 'zh' ? setStr(item.langDesc) : $langCase[item.sourceLang]+ "——"+$langCase[item.targetLang]}}</span>
              </div>
              <div class="sentence_box">
                {{$t('memoryBankV2.totalSentenceNum')}}:{{item.allSentNum}}
              </div>
            </div>
          </div>
          <div class="language_content">
            <div class="language_item" v-for="(key,index) in item.transMemoryLibDtoList"
                 :key="index" @click="toList(key)">
              <span
                    class="name">{{ $i18n.locale === 'zh' ? key.domainName : $domainCase[key.domainCode]}}</span>
              <span class="num">{{key.sentCount}}</span>
              <span class="view"></span>
            </div>
          </div>
          <div class="language_bottom">
            <div class="time">
              <p>{{item.lastUpdateTime}}</p>
            </div>
            <div class="arrow">
              <i class="el-icon-arrow-down" @click="isOpen(item,index)"
                 v-if="item.transMemoryLibDtoList.length>4"
                 :id="`${item.sourceLang}_${item.targetLang}`"></i>
            </div>
            <div class="download">
              <i class="icon_down" @click="downMemory(item)"
                 :style="$i18n.locale === 'zh'?'background-position:25px 0px':'' ">
                {{$t('memoryBankV2.Downloadall')}}</i>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 新建弹窗 -->
    <AddCorpus :isTitle="isTitle" :exportTemplateData=" exportTemplateData" :optionList="optionList"
               :langList="langList" :addShow="addShow" @closeAdd="closeAdd"
               @determineAdd="determineAdd" :disable="disable" :domainCo="domainCode" />
  </div>
</template>

<script>
import { getMemoryHomePageClassify, exportAsyncBgMemory, getMemoryDownloadAsyncResult } from "@/services/tarnslation"
import { getLang, getOptionList } from "@/services/memoryBank";
//新建记忆库
import AddCorpus from "@/components/publicCorpus/addCorpus/addCorpus";
export default {
  name: "memory",
  components: { AddCorpus },
  data() {
    return {
      languageList: [],
      transMemoryLibDtoList: [
        {
          domainName: "通用领域",
          sentCount: "4"
        },
        {
          domainName: "通用领域",
          sentCount: "4"
        }, {
          domainName: "通用领域",
          sentCount: "4"
        },
        {
          domainName: "通用领域",
          sentCount: "4"
        }, {
          domainName: "通用领域",
          sentCount: "4"
        },
        {
          domainName: "通用领域",
          sentCount: "4"
        }, {
          domainName: "通用领域",
          sentCount: "4"
        },
        {
          domainName: "通用领域",
          sentCount: "4"
        },
      ],
      langList: [], //语言表
      optionList: [], //领域数据
      isTitle: "",
      domainCode: "",
      disable: false,
      addShow: false, //新建记忆库的开关
      loading: false,
      isRequest: false,
      isShow: false,
      exportTemplateData: [
        // 模板下载数据
        { imgUrl: require("@/assets/imgs/memory/tmx_big.png"), type: "tmx" },
        { imgUrl: require("@/assets/imgs/memory/xlsx_big.png"), type: "xlsx" },
        { imgUrl: require("@/assets/imgs/memory/txt_big.png"), type: "txt" }
      ],
    }
  },

  mounted() {
    this.getMemoryLanguageList();
    this.getLang(); //获取语言对
    this.getfieldList();//获取领域
  },
  methods: {
    //展开/收缩
    isOpen(item, index) {
      let isDom = document.querySelector(`#${item.sourceLang}_${item.targetLang}`);
      let isitemDom = document.querySelector(`#${item.sourceLang}_${item.targetLang}${index}`);
      this.isShow = !this.isShow
      let Minheight = null;
      if (this.isShow) {
        isDom.className = "el-icon-arrow-up";
        isitemDom.childNodes[1].style.height = ''
        if ((item.transMemoryLibDtoList.length % 2) == 1) {
          Minheight = Math.ceil(item.transMemoryLibDtoList.length / 2) * 64 + "px"
          isitemDom.childNodes[1].style.height = Minheight;
        } else {
          Minheight = (Math.ceil((item.transMemoryLibDtoList.length - 1) / 2)) * 64 + "px";
          isitemDom.childNodes[1].style.height = Minheight;
        }
        isitemDom.childNodes[1].style.zIndex = "1000";
        isitemDom.childNodes[2].style.zIndex = "1000";
        isitemDom.style.height = "auto"
        isitemDom.childNodes[2].style.height = `calc(100% - (${Minheight} + 67px))`;
      } else {
        isDom.className = "el-icon-arrow-down";
        isitemDom.childNodes[1].style.height = "128px";
        isitemDom.childNodes[1].style.zIndex = "0";
        isitemDom.style.height = "240px"
        isitemDom.childNodes[2].style.zIndex = "0 ";
        isitemDom.childNodes[2].style.height = `calc(100% - 195px)`;
      }
    },
    toList(row) {
      this.$router.push({
        name: "tarnslationList",
        query: {
          key: this.$Base64.encode(JSON.stringify({
            nameType: "memory",
            language_name: row.langDesc,
            domainCode: row.domainCode,
            domainName: row.domainName,
            sourceLang: row.sourceLang,
            targetLang: row.targetLang
          }))
        }
      });
    },
    async getMemoryLanguageList() {
      this.loading = true;
      const { result, success } = await getMemoryHomePageClassify();
      this.loading = false;
      if (success) {
        this.isRequest = true;
        this.languageList = [...result]
        // this.languageList = result.filter(item => item.allSentNum !== 0)
      }
    },
    async getLang() {
      const { result, success } = await getLang({ type: "1" })
      if (success) {
        this.langList = result;
      }
    },
    //领域列表
    async getfieldList() {
      const { result, success } = await getOptionList({ dataType: "trans_domain" });
      if (success) {
        this.optionList = result;
      }
    },
    //创建记忆库
    addMemory() {
      this.addShow = true;
      this.isTitle = 'memoryBank'
    },
    //取消创建
    closeAdd() {
      this.addShow = false;
    },
    //确定添加
    determineAdd() {
      this.addShow = false;
      let timer = setTimeout(() => {
        timer = null;
        clearTimeout(timer)
        this.getMemoryLanguageList();
      }, 1000)
    },
    setStr(str, newstr) {
      return str = str.replace(">", newstr || "——")
    },
    handlerClick(fileName, filePath) {
      if (fileName && filePath) {
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = `/cat/api/v1/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }
    },
    //下载操作
    async downMemory(row) {
      let parasm = {};
      if (row.allSentNum !== 0) {
        this.loading = true;
        Reflect.set(parasm, "langDesc", row.langDesc)
        const { result, success } = await exportAsyncBgMemory(parasm);
        if (success) {
          if (parseInt(result.percent) === 100) {
            this.handlerClick(result.fileName, result.downloadUrl);
            this.loading = false;
          } else {
            this.getDownloadAsyncResultV2(result.taskKey);
          }
        } else {
          this.loading = false
          return;
        }
      } else {
        this.$message.closeAll();
        this.$message.warning("句对数为0不能下载");
      }
    },
    // 异步下载结果轮询接口
    getDownloadAsyncResultV2(taskKey) {
      let timer = null;
      try {
        timer = window.setInterval(async () => {
          let { resultCode, result } = await getMemoryDownloadAsyncResult({ taskKey }).catch(err => {
            clearInterval(timer);
            timer = null;
            this.loading = false;
          })
          if (resultCode === "1") {
            if (parseInt(result.percent) === 100) {
              clearInterval(timer)
              timer = null;
              this.handlerClick(result.fileName, result.downloadUrl);
              this.loading = false;
            }
          } else {
            clearInterval(timer);
            timer = null;
            this.loading = false;
          }
        }, 2000)
      } catch (error) {
        clearInterval(timer);
        timer = null;
        this.loading = false;
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>